module.exports = __webpack_public_path__ + "static/slidecard01_01-4961ddd135a8e036010e522fb02807d1.png";